import { getBasePropsFromHtmlProps } from "../../../utilities/getBasePropsFromHtmlProps";
import type { RTEBaseDefs } from "../RichTextEditorProps";
import type { RTEBaseConvertDefs } from "./getHtmlDefsFromBaseProps";

export const getBaseDefsFromHtmlProps = (baseHtmlDefs: RTEBaseConvertDefs): RTEBaseDefs => getBasePropsFromHtmlProps(baseHtmlDefs);
